import React from "react";

const Partners = () => {
  const partners = [
    { name: "Wired Learning", image: "wired-learning-color-logo-bw.png" },
    { name: "Ryich", image: "ryich-color-logo-bw.png" },
    { name: "Dhatri Fin", image: "dhatri-fin-logo-bw.png" },
    { name: "LegionX", image: "legionx-logo-transparent.png" },
    { name: "Cakes Joint", image: "cakes_joint_logo.png" },
    { name: "Raaga knots", image: "raaga-knots.png" }
  ];

  // Tripling for seamless loop
  const seamless = [...partners, ...partners, ...partners];

  return (
    <section className="w-full py-20 bg-[#F3F2ED] overflow-hidden">
      {/* Optional: Subtle Header for UX context */}
      <div className="max-w-7xl mx-auto px-6 mb-12 text-center">
        <h2 className="text-sm font-semibold tracking-widest uppercase text-gray-400">
          Trusted by Industry Leaders
        </h2>
      </div>

      <div className="relative w-full max-w-[1600px] mx-auto">
        {/* Advanced Gradient Masks - Softer transition for a "sleek" feel */}
        <div className="absolute inset-y-0 left-0 w-24 md:w-48 bg-gradient-to-r from-[#F3F2ED] to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 md:w-48 bg-gradient-to-l from-[#F3F2ED] to-transparent z-10 pointer-events-none" />

        {/* Marquee Track */}
        <div className="flex overflow-hidden">
          <div className="flex items-center gap-16 md:gap-24 animate-marquee hover:[animation-play-state:paused]">
            {seamless.map((item, i) => (
              <div 
                key={i} 
                className="flex-shrink-0 group transition-all duration-500 ease-in-out"
              >
                {/* Standardized Container:
                  - Fixed W/H for perfect uniformity
                  - Padding (p-6) prevents logos from feeling "cramped"
                  - Grayscale to Color transition for modern UX
                */}
                <div className="flex items-center justify-center w-32 h-16 md:w-48 md:h-24 px-4 grayscale opacity-50 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-700">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="max-w-full max-h-full object-contain mix-blend-multiply"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Animation Styles */}
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.33%); }
        }

        .animate-marquee {
          display: flex;
          width: max-content;
          animation: marquee 40s linear infinite;
        }

        /* Smoother rendering for webkit */
        .animate-marquee {
          will-change: transform;
          backface-visibility: hidden;
        }
      `}</style>
    </section>
  );
};

export default Partners;